import {
  ITrainingInfo,
  ITrainingInfoType
} from '../../../types/record/training-info';
import { TrainingInfoAPIRawSuccessResponseType } from '../../types/training-info/api-response';

export const ITrainingInfoFromAPISuccessResponse = ({
  id,
  status,
  name,
  rank,
  uid,
  started_at,
  finished_at,
  created_at
}: TrainingInfoAPIRawSuccessResponseType): ITrainingInfoType =>
  ITrainingInfo({
    trainingId: id,
    status,
    name,
    rank,
    uid,
    dateStarted: new Date(started_at).getTime(),
    dateFinished: new Date(finished_at).getTime(),
    dateCreated: new Date(created_at).getTime()
  });
